export const crossPostGroupKeys = {
  crossPostGroup: (workspaceId: number, crossPostGroupId: number) =>
    ['workspaces', workspaceId, 'cross_post_groups', crossPostGroupId, 'detail'] as const,
}
